export default __webpack_public_path__ + "static/media/cross.29057afb.svg";